import axios from 'axios'
import React, { useMemo, useState } from 'react'
import { Button, Col, Collapse, Row, Spinner } from 'reactstrap'
import CustomModal, { useModal } from '../../../common/CustomModal/CustomModal'
import { notificationDanger } from '../../../utils/customToastify'

const ImportLeads = ({ modalName }) => {
  const { isModalOpen, toggleModal } = useModal()
  const [file, setFile] = useState(null)
  const [collapsed, setCollapsed] = useState(true)
  const [uploading, setUploading] = useState(false)
  const [inputKey, setInputKey] = useState(0)

  const uploadDisabled = useMemo(() => {
    return !file || file.type !== 'text/csv' || uploading
  }, [uploading, file])

  const saveFile = (e) => {
    const file = e.target.files[0]

    if (file.type !== 'text/csv') {
      notificationDanger('Please provide CSV file format!')
      setInputKey((p) => ++p)
      setFile(null)

      return
    }

    setFile(file)
  }

  const uploadFile = async (e) => {
    setUploading(true)
    const formData = new FormData()
    formData.append('file', file)
    try {
      if (file.type !== 'text/csv') {
        notificationDanger('Please provide CSV file format!')
        return
      }
      await axios.post('/contacts/upload-new-leads', formData)
    } catch (err) {
    } finally {
      setUploading(false)
      toggleModal()
    }
  }

  const toggleCollapsed = () => {
    setCollapsed((prevValue) => !prevValue)
  }

  return (
    <>
      <CustomModal headerText={modalName} isOpen={isModalOpen} toggle={toggleModal}>
        <Row>
          <Col className='d-flex justify-content-between'>
            <div>
              {uploading && <Spinner style={{ height: '1rem', width: '1rem', color: 'goldenrod' }} />}
              <input key={inputKey} type='file' onChange={saveFile} disabled={uploading} />
            </div>
            <Button disabled={uploadDisabled} className={`btn btn-sm btn-gold`} onClick={uploadFile}>
              Upload
            </Button>
          </Col>
        </Row>
        <h3 className='mt-3'>Read this before importing new leads!</h3>
        <p className='text-danger'>
          <strong>WARNING: </strong> Please avoid importing large amount of data (more than 1000 rows) in the middle of
          working hours, this action has huge impact on system performances!
        </p>
        <p className='text-danger'>
          <strong>.csv is only supported file format</strong>
        </p>
        <p className='text-danger'>
          To be able to successfully import new leads CSV file must be formatted as system expects. Every file must
          contains at least those two headers (name_and_safer_name, date_entered). Headers must be placed on top of the
          file otherwise this functionality won't work as you expects.
        </p>
        <Row
          className='m-1'
          style={{ cursor: 'pointer', border: '1px solid red', borderRadius: '5px' }}
          onClick={toggleCollapsed}
        >
          <Col className='d-flex justify-content-between'>
            <div>
              <i className='fas fa-info text-danger p-3'>
                <span className='pl-1'>Supported headers that you can provide in CSV file</span>
              </i>
            </div>
            <i
              style={{ fontSize: '1rem', display: 'flex', alignItems: 'center' }}
              className={collapsed ? 'fas fa-chevron-down' : 'fas fa-chevron-up'}
            />
          </Col>
        </Row>
        <Collapse isOpen={!collapsed}>
          <Row className='m-1'>
            <Col md='4' className='text-danger font-weight-bold'>
              <p>usdot</p>
              <p>mc</p>
              <p>name_and_safer_name</p>
              <p>dba</p>
              <p>business_phone</p>
              <p>mobile_phone</p>
              <p>email</p>
              <p>street_1</p>
              <p>city</p>
            </Col>
            <Col md='4' className='text-danger font-weight-bold'>
              <p>state</p>
              <p>zip</p>
              <p>mailing_street_1</p>
              <p>mailing_city</p>
              <p>mailing_state</p>
              <p>mailing_zip</p>
              <p>owner_name</p>
              <p>source</p>
              <p>date_entered</p>
            </Col>
            <Col md='4' className='text-danger font-weight-bold'>
              <p>established_date</p>
              <p>trucks</p>
              <p>drivers</p>
              <p>entity_type</p>
              <p>operating_status</p>
              <p>cargo_carried</p>
              <p>carrier_operations</p>
              <p>operation_classification</p>
            </Col>
          </Row>
        </Collapse>

        <Button className='btn btn-sm btn-danger' onClick={toggleModal}>
          Close
        </Button>
      </CustomModal>

      <Button className={`btn btn-sm btn-gold mr-2`} onClick={toggleModal}>
        <i className='fas fa-plus mr-2' />
        Import Leads
      </Button>
    </>
  )
}

export default ImportLeads
